import _extends from "@babel/runtime/helpers/extends";
/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
const ScheduledSmallIcon = _ref => {
  let {
    size,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 12",
    fill: "currentColor",
    width: size || '22',
    height: size || '12'
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    fill: "none",
    strokeWidth: "1",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "02---Thumbnail-Components",
    transform: "translate(-1379 -6965)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/CalendarSmall-1",
    transform: "translate(1379 6965)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,6 L2,4.5 C2,4.22385542 2.22385542,3.99999389 2.5,3.99998636 C2.77613484,3.99997882 2.99999247,4.22382423 3,4.49995907 C3,4.49996362 3,4.49996817 3,4.49997271 L3,6 L4.5,6 C4.77614237,6 5,6.22385763 5,6.5 C5,6.77614237 4.77614237,7 4.5,7 L3,7 L3,8.5 C3,8.77614237 2.77614237,9 2.5,9 C2.22385763,9 2,8.77614237 2,8.5 L2,7 L0.5,7 C0.223857625,7 3.38176876e-17,6.77614237 0,6.5 C-3.38176876e-17,6.22385763 0.223857625,6 0.5,6 L2,6 Z",
    id: "Combined-Shape",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    stroke: "currentColor",
    d: "M12.5 7.5H13.5V8.5H12.5z",
    strokeWidth: "1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Combined-Shape",
    stroke: "currentColor",
    x: "9.5",
    y: "1.5",
    width: "12",
    height: "10",
    rx: "1",
    strokeWidth: "1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-10-Copy-12",
    stroke: "currentColor",
    x: "12.5",
    y: ".5",
    width: "1",
    height: "2",
    rx: ".5",
    strokeWidth: "1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-10-Copy-14",
    stroke: "currentColor",
    x: "15.5",
    y: ".5",
    width: "1",
    height: "2",
    rx: ".5",
    strokeWidth: "1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-10-Copy-17",
    stroke: "currentColor",
    x: "18.5",
    y: ".5",
    width: "1",
    height: "2",
    rx: ".5",
    strokeWidth: "1"
  })))));
};
ScheduledSmallIcon.displayName = 'ScheduledSmallIcon';
export default ScheduledSmallIcon;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=ScheduledSmallIcon.js.map